module.exports = __webpack_public_path__ + "static/img/me.ca0636e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/me.jpg
// module id = a9a6
// module chunks = 1